import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { TreeNode } from 'src/app/models/MenuData';
import { UserService } from 'src/app/services/user.service';
import swal from 'sweetalert2';
import { alphaNumericOnly,alphabetOnly,alphabetWithSpaces,numericOnly } from 'src/app/functions/validation-functions';
import { MenuService } from 'src/app/services/menu.service';
import { PasswordType } from 'src/app/models/login.component.model';
import { AdminService } from 'src/app/services/admin.service';
import * as moment from 'moment';
@Component({
  selector: 'app-users-create',
  templateUrl: './users-create.component.html',
  styleUrls: ['./users-create.component.css']
})
export class UsersCreateComponent {
  selectedIds:number[]=[];
  nodes: TreeNode[] =[];
  activeTab:number=1;
  userForm: FormGroup;
  submittedRoleForm:boolean=false;
  submittedPermissionForm:boolean=false;
  permissions: TreeNode[] = [];
  rolesList:any=[];
  GenderList:any[]=[{text:"Select Gender",value:""},{text:"Female",value:"Female"},{text:"Male",value:"Male"},{text:"Other",value:"Other"}];
  roleId:number=0;
  public passwordType: string = PasswordType.pwd;
  passwordShow:boolean = false;
  passBarWidth = "1"; 
  passBarBGColor = "#D73F40";
  passBarText="Too short";
  isMobileNumberAlreadyExists : boolean = false;
  isMobileNumberAlreadyExistsMsg : string = '';
  maxDOB = moment(new Date()).add(-18, 'years').format('YYYY-MM-DD');
  menuId:number = 0;
	menuUrl : string = "";
  constructor(private fb: FormBuilder,private userService: UserService,private router:Router,private menuService : MenuService, private adminService : AdminService) {
      this.userForm = this.fb.group({
        "userId": [0],
        "uniqueUserId": [''],
        "firstName": ['', [Validators.required]],
        "lastName": ['', [Validators.required]],
        "phoneNumber": ['', [Validators.required, Validators.pattern('[0-9]{10}')]],
        "countryCode": ['+91', [Validators.required]],
        "userEmail": ['', [Validators.required, Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')]],
        //"isLocked": [false, [Validators.required]],
        "isActive": [true],
        "userStatus": [true],
        "dob": ['', [Validators.required]],
        "gender": ['', [Validators.required]],
        "userType": [0],
        "userMenus":[],
        "userRole":["Admin"],
        "userHash": ['', [Validators.required]],
      }); 
      this.bindRolesDDL();     
      let obj = this.router.getCurrentNavigation()?.extras?.state;
      if(obj){
        this.menuId = parseInt(obj['menuId'])??0;
        this.menuUrl = obj['menuUrl'];
      }
    }

    async bindRolesDDL(){
      //this.rolesList = this.menuService.GetRolesDDL();
      let res = await this.menuService.GetRolesDDL();
        if (res != null && res.isSuccess) {
          this.rolesList = JSON.parse(res.result.obj);
          if(this.rolesList && this.rolesList.length > 0){
            this.roleId = this.rolesList[0].Id;
            this.getMenuPermissionData();
          }          
        }
    }

    async getMenuPermissionData()
    {
      const res = await this.menuService.GetMenuPermissionByRoleId(this.roleId);
        if (res != null && res.result) {    
          let userMenus =  res.result.userMenus;           
          this.userForm.get("userMenus")?.setValue(userMenus);
          this.permissions = JSON.parse(JSON.stringify(userMenus));
          for(var i=0; i<this.permissions.length; i++) { // add childs to every item
            this.permissions[i].children = [];
          }
          let tempSe = JSON.parse(JSON.stringify(this.permissions));
          this.selectedIds =tempSe.filter((f:any)=>{return f.isSelected == true}).map((m:any)=>{return m.menuId});
          this.buildTree(this.permissions,undefined);
          this.nodes = this.permissions;
        } 
    } 

  get userFormControl() {
    return this.userForm.controls;
  }

  changeTab(tab:number)
  {
    this.activeTab = tab;
  }

  async saveNext(tab:number,isPrevious:boolean = false)
  {    
    if(tab == 2 && isPrevious == false)
    {
      this.submittedRoleForm = true;
        if(this.userForm.valid && this.passBarWidth == "100" && !this.isMobileNumberAlreadyExists)
        {
          this.activeTab = tab;
        }      
    }
    else
    {
      this.activeTab = tab;
    }
  }

  ngOnInit()
  { 
    
  }
  buildTree(tree:TreeNode[], item:any) {
    if (item) { // if item then have parent
        for (var i=0; i<tree.length; i++) { // parses the entire tree in order to find the parent
            tree[i].collapsed = !tree[i].isSelected;
            if (String(tree[i].menuId) === String(item.menuAuthorityId)) { // bingo!
                item.collapsed = !item.isSelected;
                tree[i].children.push(item); // add the child to his parent
                break;
            }
            else this.buildTree(tree[i].children, item); // if item doesn't match but tree have childs then parses childs again to find item parent
        }
    }
    else { // if no item then is a root item, multiple root items are supported
        var idx = 0;
        while (idx < tree.length)
            if (tree[idx].menuAuthorityId != 0) 
            this.buildTree(tree, tree.splice(idx, 1)[0]) // if have parent then remove it from the array to relocate it to the right place
            else idx++; // if doesn't have parent then is root and move it to the next object
        }
    }

    alphabetOnly(event:any): boolean {
      return alphabetOnly(event);
    }

    alphabetWithSpace(event:any): boolean {
      return alphabetWithSpaces(event);
    }
  
    alphaNumericOnly(event:any): boolean {
      return alphaNumericOnly(event);
    }

    numericOnly(event:any): boolean {
      return numericOnly(event);
    }

    isButtonDisabled:boolean = false;
    async saveData(){
      if(this.userForm.valid)
      { 
        this.isButtonDisabled = true;
        this.userForm.get("userType")?.setValue(parseInt(this.roleId.toString()));
        this.userFormControl['userMenus'].setValue(this.userFormControl['userMenus'].value.map((m:any)=>{return {...m, isSelected: this.selectedIds.includes(m.menuId) ? true : false}}));
        let obj = {
          userId : this.userForm.value.userId,
          uniqueUserId:this.userForm.value.uniqueUserId,
          firstName:this.userForm.value.firstName,
          lastName:this.userForm.value.lastName,
          phoneNumber:this.userForm.value.phoneNumber,
          countryCode:this.userForm.value.countryCode,
          userEmail:this.userForm.value.userEmail,
          isActive:this.userForm.value.isActive,
          userStatus:this.userForm.value.userStatus,
          dob:this.userForm.value.dob,
          gender:this.userForm.value.gender,
          userType:this.userForm.value.userType,
          userMenus:this.userForm.value.userMenus,
          userRole:this.userForm.value.userRole,
          userHash : window.btoa(this.userForm.value.userHash)          
        };
        let res = await this.userService.SaveUpdateUserWithPermission(obj);
        if (res && res?.result ) {
          swal.fire({
            position: 'center',
            icon:  res?.result?.code == 1 ?'success' : 'error',
            title: res.result.message,
            showConfirmButton: false,
            timer: 3000,
          });
        }
        if(res?.result && res?.result?.code == 1)
        {
          this.homeBtClick();
        }

        setTimeout(() => {
          this.isButtonDisabled = false;
        }, 3000);
      }
    }

    onCheckChanged(selectedIDs: any) {
      this.selectedIds = selectedIDs;
    }

    onRoleChange(){
      debugger;
      let roleName = this.rolesList.filter((f:any)=>{return f.Id == this.roleId}).map((m:any)=>{return m.RoleName})[0];
      this.userForm.get("userRole")?.setValue(roleName);
      this.getMenuPermissionData()
    }

    ShowPassword() {
      if (!this.passwordShow) {
        this.passwordType = PasswordType.txt;
        this.passwordShow = true;
      }
      else {
        this.passwordType = PasswordType.pwd;
        this.passwordShow = false;
      }
    }
  
    passKeyPress(event:any){
      const charCode = (event.which) ? event.which : event.keyCode;
      if (charCode == 32) {
        return false;
      }
      return true;
    }
    passKeyUp(event:any){
        let point = 0; 
        let value = event.target.value; 
        let widthPower =  
            ["1", "25", "50", "75", "100"]; 
        let colorPower =  
            ["#D73F40", "#DC6551", "#F2B84F", "#BDE952", "#3ba62f"];
        let textPower =  
            ["Too short", "Weak", "Fair", "Good", "Strong"]; 
      
        if (value.length >= 8) { 
            let arrayTest =  
                [/[0-9]/, /[a-z]/, /[A-Z]/, /[^0-9a-zA-Z]/]; 
            arrayTest.forEach((item) => { 
                if (item.test(value)) { 
                    point += 1; 
                } 
            }); 
        } 
        this.passBarWidth = widthPower[point]; 
        this.passBarBGColor = colorPower[point];
        this.passBarText = textPower[point];
    }

    async checkPhoneNumberExists(){
      this.isMobileNumberAlreadyExistsMsg = "";
      this.isMobileNumberAlreadyExists = false;
      if(this.userForm.get('phoneNumber')?.value?.length == 10){
        let obj = {
          phoneNumber : this.userForm.get('phoneNumber')?.value?.toString()
        }
        const res = await this.adminService.CheckPhoneNumberExists(obj);   
        if (res != null && res.result && res.result.code == 0) {
          this.isMobileNumberAlreadyExistsMsg = res.result.message;
          this.isMobileNumberAlreadyExists = true;
          swal.fire({
            position: 'center',
            icon: 'error',
            title: res.result.message,
            showConfirmButton: false,
            timer: 3000,
          });
        }
        else 
        {
          this.isMobileNumberAlreadyExists = false;
          this.isMobileNumberAlreadyExistsMsg = '';
        }  
      }    
    }

    homeBtClick(){
      this.router.navigateByUrl(this.menuUrl,{ state: { menuId:this.menuId, menuUrl : this.menuUrl }});
    }
}
